import { Column, Entity, PrimaryColumn } from 'typeorm';

import { UserDetail } from '../../_objects/user';
import { TenantIdSchemaBase } from '../interfaces/tenantId.base';

/**
 * UserSchema インターフェイス。
 */
export interface IUserSchema {
  id: string;
  givenName: string;
  surname: string;
  tenantId: string;
  email: string;
  telephoneNumber: string;
  isActive: boolean;
  isSubscription: boolean;
}

@Entity()
export class UserSchema implements TenantIdSchemaBase, IUserSchema {
  @PrimaryColumn()
    id: string;
  @Column({ nullable: true })
    givenName: string | null;
  @Column({ nullable: true })
    surname: string | null;
  @Column({ nullable: true })
    tenantId: string | null;
  @Column({ nullable: true })
    email: string | null;
  @Column({ nullable: true })
    telephoneNumber: string | null;

  @Column({ nullable: true })
    isActive: boolean;
  @Column({ nullable: true })
    isSubscription: boolean;

  constructor(tenantId: string, user?: UserDetail | IUserSchema) {
    if (user) {
      this.id = user.id;
      this.givenName = user.givenName;
      this.surname = user.surname;
      this.tenantId = tenantId;
      this.email = user.email;
      this.telephoneNumber = user.telephoneNumber;
      this.isActive = user.isActive;
      this.isSubscription = user.isSubscription;
    }
  }
}
